module.exports = __webpack_public_path__ + "img/package.3ccbeb27.svg";